import { c as _c } from "react/compiler-runtime";
import type { VaultData } from '@onefootprint/request-types';
import { Button, Form, PageShell } from '@onefootprint/ui';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ConsentFooter } from '@/idv2/components/consent-footer';
type ErrorCallback = (message: string) => void;
export type CollectEmailProps = {
  onSubmit?: (data: VaultData, onError: ErrorCallback) => void;
  isLoading?: boolean;
  defaultEmail?: string;
  showLegalFooter?: boolean;
};
type CollectEmailFormData = {
  email: string;
};
export const CollectEmail = t0 => {
  const $ = _c(43);
  const {
    onSubmit,
    isLoading: t1,
    defaultEmail,
    showLegalFooter: t2
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  const showLegalFooter = t2 === undefined ? false : t2;
  const {
    t
  } = useTranslation("idv2");
  const t3 = defaultEmail ?? "";
  let t4;
  if ($[0] !== t3) {
    t4 = {
      defaultValues: {
        email: t3
      }
    };
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const methods = useForm(t4);
  let t5;
  if ($[2] !== methods || $[3] !== onSubmit) {
    t5 = async data => {
      const vaultData = {
        "id.email": data.email
      };
      const onError = message => {
        methods.setError("email", {
          message
        });
      };
      onSubmit?.(vaultData, onError);
    };
    $[2] = methods;
    $[3] = onSubmit;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const handleSubmit = t5;
  let t6;
  if ($[5] !== t) {
    t6 = t(_temp);
    $[5] = t;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t) {
    t7 = t(_temp2);
    $[7] = t;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== handleSubmit || $[10] !== methods) {
    t8 = methods.handleSubmit(handleSubmit);
    $[9] = handleSubmit;
    $[10] = methods;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t) {
    t9 = t(_temp3);
    $[12] = t;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t) {
    t10 = t(_temp4);
    $[14] = t;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t) {
    t11 = t(_temp5);
    $[16] = t;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11) {
    t12 = {
      required: t11
    };
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t10 || $[21] !== t12 || $[22] !== t9) {
    t13 = <Form.Email label={t9} name="email" placeholder={t10} rules={t12} />;
    $[20] = t10;
    $[21] = t12;
    $[22] = t9;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t) {
    t14 = t(_temp6);
    $[24] = t;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== isLoading || $[27] !== t14) {
    t15 = <Button type="submit" variant="primary" fullWidth={true} size="large" loading={isLoading}>{t14}</Button>;
    $[26] = isLoading;
    $[27] = t14;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t13 || $[30] !== t15 || $[31] !== t8) {
    t16 = <form onSubmit={t8} className="flex flex-col gap-4 items-start w-full" data-dd-privacy="mask">{t13}{t15}</form>;
    $[29] = t13;
    $[30] = t15;
    $[31] = t8;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== methods || $[34] !== t16) {
    t17 = <FormProvider {...methods}>{t16}</FormProvider>;
    $[33] = methods;
    $[34] = t16;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== showLegalFooter) {
    t18 = showLegalFooter && <ConsentFooter requiredConsent={[{
      kind: "terms_and_conditions"
    }]} />;
    $[36] = showLegalFooter;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== t17 || $[39] !== t18 || $[40] !== t6 || $[41] !== t7) {
    t19 = <PageShell title={t6} subtitle={t7}>{t17}{t18}</PageShell>;
    $[38] = t17;
    $[39] = t18;
    $[40] = t6;
    $[41] = t7;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  return t19;
};
export default CollectEmail;
function _temp($) {
  return $.identify.email.title;
}
function _temp2($_0) {
  return $_0.identify.email.subtitle;
}
function _temp3($_1) {
  return $_1.identify.email.label;
}
function _temp4($_2) {
  return $_2.identify.email.placeholder;
}
function _temp5($_3) {
  return $_3.identify.email.requiredError;
}
function _temp6($_4) {
  return $_4.identify.email.continue;
}